import OA from '../../components/identidades/OA';
import Header from '../../components/Header'

function OAPage() {
    window.scrollTo(0, 0);
    return (
        <div>
            <Header isComunicacao={true}></Header>
            <OA />
        </div>
    )
}

export default OAPage;